import avatar from '../../public/img/avatar.png'
import itemsSocial from './social'

const hero = (state) => `
<section id="hero">
    <section class='justify-content-center mt-6'>
        <img src="${avatar}" alt="Juan López Aragon"/>
    </section>
    <section class='hero-about'>
        <h1 class='mt-4'>${state.title}</h1>
        <h2 class='mt-2'>${state.subtitle}</h2>
        <ul class='row justify-content-center mt-5'> 
            ${itemsSocial(state)}
        </ul>
    </section>
</section>`

export default hero
